<template>
  <div>
    <div class="title-block">決済方法を選択してください</div>
    <div class="column">
      <div class="field">
        <div class="select-wrap">
          <select @change="handleChangePaymentMethod">
            <option
              v-for="(option, index) in paymentMethods"
              :key="index"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <p class="text-block">
      まだ座席は確保されていません。座席が確保できない場合がありますのでご了承ください。
    </p>
  </div>
</template>

<script>
import { onMounted, computed, watch, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";
import { useStore } from "vuex";

export default {
  name: "MFITTBookingSelectPaymentMethod",
  props: {},
  setup(props) {
    const store = useStore();

    const selectedPaymentMethod = computed(
      () => store.getters["MFITT/selectedPaymentMethod"]
    );
    const paymentMethods = computed(
      () => store.getters["MFITT/paymentMethods"]
    );

    const handleChangePaymentMethod = (event) => {
      const selectedMethod = event.target.value;
      store.commit("MFITT/setSelectedPaymentMethod", selectedMethod);
    };

    return {
      props,
      selectedPaymentMethod,
      paymentMethods,
      handleChangePaymentMethod,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.text-block {
  margin: 50px 6px;
  text-align: left;
  font-size: 14px;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

.field {
  position: relative;
  margin: 0 0 0 0;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 75px;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: bold;
  color: #000000;
}
/* 横幅375px以下に適用されるCSS（iPhone SE 第2世代以下のサイズ用） */
@media screen and (max-width: 375px) {
  select {
    font-size: 0.75rem;
  }
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::before {
  content: "決済方法";
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 13px;
  color: gray;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -4px;
}
</style>
